<script>
  import { formatMoney, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import ConfirmAddon from './ConfirmAddon.svelte';
  import { fly } from 'svelte/transition';
  import { External, M } from '../../external';
  import { disableAddon } from './addons';

  export let onChange = ignore, onCancel = ignore, addon = null, subscription, showLimitsReachedMessage = false;
  let addons = [];
  let confirming = false;
  let initialValue = 0;

  let disable = async () => {
    let result = await disableAddon(addon);
    if (result) {
      onChange(result);
    }
  };

  onMount(() => {
    addons = External.Website.addons.filter(addon => addon.type === 'FUNNELS');
    if (addon) {
      initialValue = addon.value;
    } else {
      addon = subscription.addons.find(addon => addon.type === 'FUNNELS');
      if (addon) {
        initialValue = addon.value;
      } else {
        addon = addons[0];
      }
    }
  });
</script>
<div class="popup-widget-wrapper" style="overflow-x: hidden">

  <div class="col20 f-left t-left flex align-center flex-col">
    <h2 class="col20 f-left mt-15 t-center big-title-popup">{M.EXTRA_FUNNEL}</h2>
    {#if showLimitsReachedMessage}
      <h4 class="col20 f-left mt-15 t-center big-title-popup">{M.RESOURCE_LIMIT_REACHED}</h4>
    {/if}
    <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{M.EXTRA_FUNNEL_DESC}</div>
  </div>

  {#if confirming}
    <div class="col20 f-left" in:fly={{x: '100%'}}>
      <ConfirmAddon {addon} currency={subscription.currency} value={addon?.value} taxRate={subscription.activeVatPercent}
                    on:cancel={() => confirming = false}
                    on:confirm={(event) => onChange(event.detail)} />
    </div>
  {:else}
    <div class="price-tables-wrapper table-of-one style-1 layout-2 col20 f-left mt-15 flex-col" in:fly={{x: '-100%'}}>

      <div class="col20 f-left mb-15 flex justify-center align-center">
        {#each addons as add}
          <a class="addon-quantity-select" class:active={addon?.value === add.value} on:click={() => addon = add}>
            {add.value === 999 ? M.UNLIMITED : add.value}
          </a>
        {/each}
      </div>

      <div class="price-table most-popular highlight-table">
        <div class="price-table-inner">
          <h3 class="price-table-value monthly">
            {@html formatMoney(addon?.monthlyPrice || 0, subscription.currency, true, true)}
            <span class="price-table-period">/{M.MONTH}</span>
            {#if subscription.activeVatPercent}
              <span class="col20 f-left mt-5 price-table-support-text">{M.TAX_PLUS}</span>
            {/if}
          </h3>
          <div class="price-table-description">
            <ul class="icon-list-wrapper">
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">
                  {#if addon?.value === 1}
                    {M.ONE_FUNNEL}
                  {:else if addon?.value === 999}
                    {M.UNLIMITED_FUNNELS}
                  {:else}
                    {addon?.value || 0} {M.FUNNELS}
                  {/if}
                </span>
              </li>
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">{M.UNLIMITED_PAGES}</span>
              </li>
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">{M.UNLIMITED_POPUPS}</span>
              </li>
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">{M.DOMAIN_CONNECTION_WITH_EVERY}</span>
              </li>
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">{M.FUNNEL_ANALYTICS}</span>
              </li>
              <li class="icon-list-item">
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                </svg>
                <span class="icon-list-name">{M.FUNNEL_UP_DOWN}</span>
              </li>
            </ul>
          </div>
          <div class="price-table-footer">
            {#if addon?.value === initialValue}
              <a class="price-table-button disabled">
                {M.YOUR_CURRENT_LIMIT}
              </a>
            {:else}
              <a class="price-table-button" on:click={() => confirming = true}>
                {addon?.value > initialValue ? M.UPGRADE : M.CHANGE}
                <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                  <path
                    d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
                </svg>
              </a>
            {/if}
          </div>
        </div>
      </div>
    </div>
    {#if initialValue}
      <a class="col20 f-left t-center text-link-hover mt-15" on:click={disable}>{M.REMOVE_ADDON}</a>
    {:else}
      <a class="col20 f-left t-center help-text mt-15" on:click={() => onCancel(true)}>{M.MANAGE_ADDONS_BILLING}</a>
    {/if}
  {/if}
</div>
